import React from 'react'

//REACT TOOLBOX
import Button from 'react-toolbox/lib/button/Button';


const NavigationComponent = props => {
    return(
        <li className="active">
            <div className="navButton">
                <Button icon={props.icon} accent>{props.text}</Button>
            </div>
        </li>
    )
};

export default NavigationComponent;


// WEBPACK FOOTER //
// ./src/components/DashBoard/SideBar/NavigationComponent.js